import { LmIconOutlineHardwarePresentTripod } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconScienceEmploymentsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? (
    <LmIconOutlineHardwarePresentTripod {...rest} />
  ) : (
    <LmIconOutlineHardwarePresentTripod {...rest} />
  );

export default IconScienceEmploymentsCommon;
